<style>
.badge-container {
  background-size: contain;
  width: 100%;
  height: 20px;
}

.badge-container .badge-text {
  font-size: 12px;
  padding: 2px;
  color: #ffffff;
}

.badge-container .badge-text.badge-text-bottom {
  position: relative;
  top: -2px;
}

.preview {
  background: #36393e;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  max-width: 520px;
}

.side-colored {
  width: 4px;
  border-radius: 3px 0 0 3px;
  background: #4f545c;
}

.embed {
  border-radius: 0 3px 3px 0;
  background: rgba(46, 48, 54, 0.3);
  border-color: rgba(46, 48, 54, 0.6);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 8px 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.embed .card-block {
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}

.embed a {
  color: #0096cf;
}

.embed img.embed-thumb {
  max-height: 384px;
  max-width: 384px;
  border-radius: 3px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: auto;
  -o-object-fit: contain;
  object-fit: contain;
}

.embed .embed-footer {
  font-size: 12px;
}

.embed .embed-footer span {
  color: rgba(255, 255, 255, 0.6);
}

.embed .embed-inner .embed-title {
  font-size: 18px;
  color: #ffffff;
}

.embed .embed-inner .embed-author {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 5px;
}

.embed .embed-inner .embed-author img.embed-author-icon {
  margin-right: 9px;
  width: 20px;
  height: 20px;
  -o-object-fit: contain;
  object-fit: contain;
  border-radius: 50%;
}

.embed .embed-inner .embed-author .embed-author-name {
  display: inline-block;
  font-weight: bold;
  font-size: 20px;
  text-decoration: none;
  color: #ffffff !important;
}

.embed .embed-inner .fields {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  box-lines: miltiple;
  margin-top: -10px;
}

.embed .embed-inner .fields .field {
  -webkit-box-flex: 0;
  -ms-flex: 0;
  flex: 0;
  box-flex: 1;
  padding-top: 10px;
  max-width: 506px;
  min-width: 100%;
}

.embed .embed-inner .fields .field.inline {
  box-flex: 1;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-width: 150px;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}

.embed .embed-inner .fields .field .field-name {
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 600;
}

.embed .embed-inner .fields .field .field-value {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.1em;
  white-space: pre-wrap;
  margin-top: 6px;
  word-wrap: break-word;
}

.sticky {
  position: fixed;
  top: 15;
  width: 100%;
  z-index: 100;
}
</style>
<template>
  <div id="settings">
    <v-dialog v-model="apiKeys.add.dialog" max-width="600px">
      <v-card elevation="7" class="rounded-xl">
        <v-card-title class="headline">Add API Key</v-card-title>
        <v-card-text v-if="!apiKeys.add.key">
          <v-text-field
            v-model="apiKeys.add.name"
            label="Name"
            required
          ></v-text-field>
          <!-- date picker for expiry -->
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="apiKeys.add.expiry"
                label="Expiry"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="apiKeys.add.expiry"
              no-title
              color="primary"
              scrollable
            ></v-date-picker>
          </v-menu>
          <v-treeview
            v-model="apiKeys.add.scopes"
            :items="apiKeys.add.availableScopes"
            open-on-click
            hoverable
            selectable
            dense
            multiple
            transition
            class="elevation-1"
            selected-color="primary"
          >
          </v-treeview>
        </v-card-text>
        <v-card-text v-else>
          <v-text-field
            v-model="apiKeys.add.key"
            label="Key"
            disabled
            readonly
          ></v-text-field>
          <p>
            Use this key with any TPU integrations. This is a secret, do not
            share it with anyone.
          </p>
        </v-card-text>
        <v-card-actions v-if="!apiKeys.add.key">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="apiKeys.add.dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" text @click="addApiKey">Add</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              apiKeys.add.key = ''
              apiKeys.add.dialog = false
            "
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="credits.dialog" max-width="600px">
      <v-card v-if="credits.stage === 1" class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5"
            >Purchasing {{ $store.state.site.name }} Credits</span
          >
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="rounded-xl"
                  v-model="credits.amount"
                  :outlined="!$store.state.site.whitelabel"
                  label="Amount of USD to deposit:"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="credits.dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="credits.loading"
            color="blue darken-1"
            text
            @click="initCredits()"
          >
            Pay
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="credits.stage === 2" class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5">Select Cryptocurrency</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-chip class="ma-1" @click="setCoin('bitcoin')">Bitcoin</v-chip>
            <v-chip class="ma-1" @click="setCoin('ethereum')">Ethereum</v-chip>
            <v-chip class="ma-1" @click="setCoin('usdc')">USDC</v-chip>
            <v-chip class="ma-1" @click="setCoin('litecoin')">Litecoin</v-chip>
            <v-chip class="ma-1" @click="setCoin('bitcoincash')"
              >Bitcoin Cash
            </v-chip>
            <v-chip class="ma-1" @click="setCoin('dai')">DAI</v-chip>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="credits.dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="credits.stage === 3" class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5">Send Payment</span>
        </v-card-title>

        <v-card-text>
          <v-container class="justify-center text-center">
            <div v-if="credits.selectedCrypto === 'bitcoin'">
              <p>
                Send
                <code>{{ credits.response.pricing.bitcoin.amount }}</code> in
                Bitcoin to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.bitcoin"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip @click="copyAddress(credits.response.addresses.bitcoin)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
            <div v-if="credits.selectedCrypto === 'ethereum'">
              <p>
                Send
                <code>{{ credits.response.pricing.ethereum.amount }}</code> in
                Ethereum to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.ethereum"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip @click="copyAddress(credits.response.addresses.ethereum)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
            <div v-if="credits.selectedCrypto === 'bitcoincash'">
              <p>
                Send
                <code>{{ credits.response.pricing.bitcoincash.amount }}</code>
                in Bitcoin Cash to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.bitcoincash"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip
                @click="copyAddress(credits.response.addresses.bitcoincash)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
            <div v-if="credits.selectedCrypto === 'usdc'">
              <p>
                Send <code>{{ credits.response.pricing.usdc.amount }}</code> in
                USDC to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.usdc"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip @click="copyAddress(credits.response.addresses.usdc)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
            <div v-if="credits.selectedCrypto === 'litecoin'">
              <p>
                Send
                <code>{{ credits.response.pricing.litecoin.amount }}</code> in
                Litecoin to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.litecoin"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip @click="copyAddress(credits.response.addresses.litecoin)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
            <div v-if="credits.selectedCrypto === 'dai'">
              <p>
                Send <code>{{ credits.response.pricing.dai.amount }}</code> in
                DAI to the address below:
              </p>
              <v-text-field
                class="rounded-xl"
                v-model="credits.response.addresses.dai"
                :outlined="!$store.state.site.whitelabel"
                disabled
              >
              </v-text-field>
              <v-chip @click="copyAddress(credits.response.addresses.dai)"
                >Copy Address
              </v-chip>
              <br />
              <p>
                You have 1 hour to complete the transaction. Sending through the
                wrong blockchain may result in a loss of funds.
              </p>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="credits.dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="credits.stage === 4" class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5">Thank You</span>
        </v-card-title>

        <v-card-text>
          <v-container class="justify-center text-center">
            Your transaction was successful.
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="credits.dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-card class="rounded-lg" elevation="7">
        <v-tabs color="#007aff">
          <v-tab name="account">
            <v-icon left> mdi-account</v-icon>
            Account
          </v-tab>
          <v-tab name="customization">
            <v-icon left> mdi-brush</v-icon>
            Customization
          </v-tab>
          <v-tab name="themes">
            <v-icon left> mdi-brush</v-icon>
            Themes
          </v-tab>
          <v-tab name="navigation" v-if="$vuetify.breakpoint.mdAndUp">
            <v-icon left>
              {{
                $store.state.navigation === "sidebar"
                  ? "mdi-page-layout-sidebar-left"
                  : "mdi-page-layout-header"
              }}</v-icon
            >
            Navigation
          </v-tab>
          <v-tab name="clients">
            <v-icon left> mdi-lock</v-icon>
            Clients
          </v-tab>
          <v-tab name="accounts">
            <v-icon left> mdi-link</v-icon>
            API Keys
          </v-tab>
          <v-tab name="billing" v-if="false">
            <v-icon left> mdi-credit-card</v-icon>
            Subscriptions
          </v-tab>
          <v-tab name="billing">
            <v-icon left> mdi-image-multiple</v-icon>
            Slideshow
          </v-tab>
          <v-tab name="pages" v-if="false">
            <v-icon left> mdi-book</v-icon>
            Pages
          </v-tab>
          <v-tab name="about">
            <v-icon left> mdi-information</v-icon>
            About
          </v-tab>
          <v-tab-item>
            <v-container>
              <v-form>
                <div class="text-h5">Avatar</div>
                <div class="text-subtitle-1">
                  This avatar will appear on your profile, the users page, and
                  your personalized page if you have one.
                </div>
                <v-file-input
                  class="rounded-xl"
                  v-model="avatar.file"
                  :outlined="!$store.state.site.whitelabel"
                  :rules="avatar.rules"
                  accept="image/png, image/jpeg"
                  label="Avatar"
                  placeholder="Pick an avatar"
                  prepend-icon="mdi-camera"
                ></v-file-input>
                <v-btn
                  :loading="avatar.loading"
                  class="ma-1 rounded-xl"
                  @click="changeAvatar()"
                >
                  Upload avatar
                </v-btn>
                <v-btn
                  :loading="avatar.loadingRemove"
                  class="ma-1 rounded-xl"
                  @click="removeAvatar()"
                >
                  Remove avatar
                </v-btn>
                <br />
              </v-form>
            </v-container>
            <v-container>
              <v-form>
                <div class="text-h5">Privacy</div>
                <v-checkbox
                  v-model="privacy.discordPrecache"
                  label="Enable Discord Precaching"
                  class="mb-n4"
                ></v-checkbox>
                <small
                  >Discord precaching sends the TPU link of any image, or video
                  to a Discord channel that gets cleared every 10 minutes in
                  order to have the image cached by Discord by the time its sent
                  by yourself.
                  <b>Do not enable this if you don't trust Discord.</b></small
                >
                <v-checkbox
                  v-model="privacy.usernameHidden"
                  label="Hide username from your uploads"
                ></v-checkbox>
                <p>
                  Remember to change your embed settings, as the dynamic tags
                  will override this setting.
                </p>
                <v-btn
                  class="rounded-xl"
                  :loading="privacy.loading"
                  @click="setUploadNameHidden"
                  >Save Changes
                </v-btn>
              </v-form>
            </v-container>
            <v-container>
              <v-form>
                <div class="text-h5 mb-4">Change description</div>
                <v-textarea
                  class="rounded-xl"
                  label="Description"
                  v-model="description.description"
                  :outlined="!$store.state.site.whitelabel"
                ></v-textarea>
                <v-btn
                  class="rounded-xl"
                  :loading="description.loading"
                  @click="changeDescription()"
                  >Change description
                </v-btn>
              </v-form>
            </v-container>
            <div class="container">
              <v-form>
                <div class="text-h5 mb-4">Change Username</div>
                <template v-if="!$store.state.user.flowinityId">
                  <v-text-field
                    class="rounded-xl"
                    v-model="username.username"
                    :outlined="!$store.state.site.whitelabel"
                    label="New Username"
                    @keyup.enter="changeUsername()"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="username.password"
                    :outlined="!$store.state.site.whitelabel"
                    label="Current Password"
                    type="password"
                    @keyup.enter="changeUsername()"
                  ></v-text-field>
                  <v-btn
                    class="rounded-xl"
                    :loading="username.loading"
                    @click="changeUsername()"
                    >Change Username
                  </v-btn>
                </template>
                <p v-else>
                  Please contact Troplo to request a username change.
                </p>
              </v-form>
            </div>
            <div class="container">
              <v-form>
                <div class="text-h5 mb-4" v-if="$store.state.user.flowinityId">
                  Change Email/Password and 2FA Settings
                </div>
                <div class="text-h5 mb-4" v-else>Change Email</div>
                <p v-if="$store.state.user.flowinityId">
                  Adjustments to your email, password, and 2FA settings must be
                  adjusted
                  <a
                    href="https://sso.flowinity.com/auth/realms/master/account"
                    style="text-decoration: none"
                    >here</a
                  >.<br />If you'd like to request account deletion, or any
                  other destructive actions related to your TPU account, you
                  must contact Troplo.
                </p>
                <template v-else>
                  <p>
                    Your email is currently set to
                    <strong> {{ $store.state.user.email }}</strong>
                  </p>
                  <v-text-field
                    class="rounded-xl"
                    v-model="email.email"
                    :outlined="!$store.state.site.whitelabel"
                    label="New Email"
                    @keyup.enter="changeEmail()"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="email.password"
                    :outlined="!$store.state.site.whitelabel"
                    label="Current Password"
                    type="password"
                    @keyup.enter="changeEmail()"
                  ></v-text-field>
                  <v-btn
                    class="rounded-xl"
                    :loading="email.loading"
                    @click="changeEmail()"
                    >Change Email
                  </v-btn></template
                >
              </v-form>
            </div>
            <div class="container" v-if="!$store.state.user.flowinityId">
              <v-form>
                <div class="text-h5 mb-4">Change Password</div>
                <v-text-field
                  class="rounded-xl"
                  v-model="password.password"
                  :outlined="!$store.state.site.whitelabel"
                  label="New Password"
                  type="password"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-model="password.confirmPassword"
                  :outlined="!$store.state.site.whitelabel"
                  label="Confirm New Password"
                  type="password"
                  @keyup.enter="changePassword()"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-model="password.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  label="Current Password"
                  type="password"
                  @keyup.enter="changePassword()"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="password.loading"
                  @click="changePassword()"
                  >Change Password
                </v-btn>
              </v-form>
            </div>
            <!--<div class="container">
              <v-alert color="error darken-1" type="error">
                <p v-if="$store.state.site.release === 'dev'" class="text-h6">
                  Automated Wipe Gallery
                </p>
                <p v-if="$store.state.site.release === 'dev'">
                  If you wish, you can your gallery to be wiped automatically at
                  intervals. They will be gone forever, so be careful!
                </p>
                <v-select
                  v-if="$store.state.site.release === 'dev'"
                  v-model="wipeGallery.automated.selected"
                  :items="wipeGallery.automated.items"
                  color="white"
                  item-text="name"
                  item-value="internalName"
                  label="Type"
                >
                </v-select>
                <v-text-field
                  class="rounded-xl"
                  v-if="
                    wipeGallery.automated.selected !== 'disabled' &&
                    $store.state.site.release === 'dev'
                  "
                  v-model="wipeGallery.automated.time"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Time (in days)"
                  type="number"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-if="$store.state.site.release === 'dev'"
                  v-model="wipeGallery.automated.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Current Password"
                  type="password"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  v-if="$store.state.site.release === 'dev'"
                  :loading="wipeGallery.loading"
                  @click="saveWipeGallery()"
                  >Save
                </v-btn>
                <br v-if="$store.state.site.release === 'dev'" /><br
                  v-if="$store.state.site.release === 'dev'"
                />
                <p class="text-h6">Wipe Gallery</p>
                <p>
                  If you wish, you can delete all the items in your gallery.
                  They will be gone forever, so be careful!
                </p>
                <v-text-field
                  class="rounded-xl"
                  v-model="wipeGallery.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Current Password"
                  type="password"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="wipeGallery.loading"
                  @click="doWipeGallery()"
                  >Wipe Gallery
                </v-btn>
              </v-alert>
            </div>-->
            <div class="container">
              <v-alert
                v-if="totp.stage === 0 && !$store.state.user.totpEnable"
                type="info"
              >
                <p class="text-h6">
                  Enable 2 Factor Authentication (Highly Recommended)
                </p>
                <p>
                  Enabling 2FA will add another secure authentication layer to
                  your account, this will make it extremely hard for anyone but
                  yourself to login to your account, however, if you loose the
                  device that handles your 2FA codes, you will permanently loose
                  access to your account. We recommend using Twilio Authy
                  because it has code backup.
                </p>
                <v-text-field
                  class="rounded-xl"
                  v-model="totp.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Current Password"
                  type="password"
                  @keyup.enter="doEnable2FA()"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="totp.loading"
                  @click="doEnable2FA()"
                  >Get Started
                </v-btn>
              </v-alert>
              <v-alert
                v-if="totp.stage === 0 && $store.state.user.totpEnable"
                :type="calculateDangerTOTP()"
              >
                <p v-if="!totp.disable.currentPassword" class="text-h6">
                  2FA is enabled.
                </p>
                <p v-if="!totp.disable.currentPassword">
                  Thanks for making your account more secure!
                </p>
                <p v-if="totp.disable.currentPassword" class="text-h6">
                  Are you sure?
                </p>
                <p v-if="totp.disable.currentPassword">
                  When disabling 2FA your account will be significantly less
                  secure.
                </p>
                <v-text-field
                  class="rounded-xl"
                  v-model="totp.disable.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Current Password"
                  type="password"
                  @keyup.enter="doDisable2FA()"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-model="totp.disable.code"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="2FA Code"
                  placeholder="123456"
                  type="number"
                  @keyup.enter="doDisable2FA()"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="totp.disable.loading"
                  @click="doDisable2FA()"
                  >Disable 2FA
                </v-btn>
              </v-alert>
              <v-alert v-if="totp.stage === 1" type="info">
                <p class="text-h6">
                  Enter the code, or scan the QR code in your TOTP/2FA client (6
                  digits).
                </p>
                <code>{{ totp.validate.token }}</code
                ><br />
                <VueQrcode
                  :options="{ width: 250 }"
                  :value="totp.validate.url"
                />
                <p>
                  Once you've added {{ $store.state.site.name }} into your TOTP
                  client, enter the code below to validate that it's working
                  correctly.
                </p>
                <v-text-field
                  class="rounded-xl"
                  v-model="totp.validate.code"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="2FA Code"
                  placeholder="123456"
                  type="number"
                  @keyup.enter="doValidate2FA()"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="totp.validate.loading"
                  @click="doValidate2FA()"
                  >Validate & Enable
                </v-btn>
              </v-alert>
              <p v-if="!$store.state.user.flowinityId">
                If you'd like to request account deletion, or any other
                destructive actions related to your TPU account, please email
                <a href="mailto:troplo@troplo.com">troplo@troplo.com</a>.
              </p>
            </div>
            <!--<div class="container">
              <v-alert color="error darken-1" type="error">
                <p class="text-h6">Delete Account</p>
                <p>
                  Deleting your account will permanently remove all your
                  uploads, cancel any ongoing subscriptions, and your account
                  will be gone forever!
                </p>
                <v-text-field
                  class="rounded-xl"
                  v-model="deleteAccount.currentPassword"
                  :outlined="!$store.state.site.whitelabel"
                  color="white"
                  label="Current Password"
                  type="password"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="deleteAccount.loading"
                  @click="doDeleteAccount()"
                  >Delete Account
                </v-btn>
              </v-alert>
            </div>-->
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-form>
                <v-row>
                  <v-col>
                    <div class="text-h5">Other</div>
                    <p v-if="customization.invisibleURLs">
                      <br />Discord Fake URLs are unavailable with invisible
                      URLs being enabled.
                    </p>
                    <v-checkbox
                      v-if="!customization.invisibleURLs"
                      v-model="customization.fakePath"
                      label="Fake URLs (Discord Only)"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-checkbox>
                    <v-text-field
                      class="rounded-xl"
                      v-if="
                        customization.fakePath && !customization.invisibleURLs
                      "
                      v-model="customization.fakePathValue"
                      :outlined="!$store.state.site.whitelabel"
                      label="Fake URLs Value (Dynamic Tags Allowed)"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <small v-if="!customization.invisibleURLs"
                      >These paths will appear as a different domain, and path
                      to the Discord client, however the embed will still appear
                      as if its the proper path. (Example:
                      https://google.com/[attachment.name])</small
                    >
                    <p v-if="customization.fakePath">
                      <br />Invisible URLs are unavailable with Discord Fake
                      URLs being enabled.
                    </p>
                    <v-checkbox
                      v-if="!customization.fakePath"
                      v-model="customization.invisibleURLs"
                      label="Invisible URLs**"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-checkbox>
                    <p v-if="customization.fakePath">
                      Custom Paths are unavailable with Discord Fake URLs being
                      enabled.
                    </p>
                    <p v-if="!customization.openGraph">
                      Custom Paths are unavailable with embeds being disabled.
                    </p>
                    <v-text-field
                      class="rounded-xl"
                      v-if="!customization.fakePath && customization.openGraph"
                      v-model="customization.customPath"
                      :outlined="!$store.state.site.whitelabel"
                      label="Custom Path"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <small v-if="!customization.fakePath"
                      >Custom paths must start, and end with a slash. (Example:
                      /my/custom/path/)
                      <br />
                    </small>
                    <small
                      >** These features will partially not work if you have
                      embeds disabled. Invisible URLs will appear like
                      domain.com/i/</small
                    >
                    <br />
                    <div class="text-h5">Embed Settings</div>
                    <v-checkbox
                      v-model="customization.openGraph"
                      label="Enable embeds (disabling will serve the direct download URL to your client)"
                    ></v-checkbox>
                    <v-alert type="warning">
                      Some meta tags may not work as intended on certain types
                      of files, for example, certain tags will be excluded on
                      video embeds.
                    </v-alert>
                    <v-alert
                      v-if="
                        !customization.openGraphTitle &&
                        !customization.oEmbedAuthorName
                      "
                      type="warning"
                    >
                      An author or title is required for Discord embeds to
                      function correctly.
                    </v-alert>
                    <v-expansion-panels v-model="panel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          >Dynamic Tags
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          Dynamic tags can be used to change what content
                          depending on the file uploaded on your embed. We are
                          likely to remove or add dynamic tags in the future.
                          The current list are as follows:
                          <ul>
                            <li>
                              <b>[user.username]</b> (Your currently logged in
                              username, Example Response:
                              {{ $store.state.user.username }})
                            </li>
                            <li>
                              <b>[user.id]</b> (Your currently logged in user's
                              ID, Example Response: {{ $store.state.user.id }})
                            </li>
                            <li>
                              <b>[attachment.id]</b> (The attachment's ID,
                              Example Response: 56)
                            </li>
                            <li>
                              <b>[attachment.fileName]</b> (The attachment's
                              randomized file name when it gets uploaded to
                              {{ $store.state.site.name }}, Example Response:
                              2327417e.png)
                            </li>
                            <li>
                              <b>[attachment.name]</b> (The attachment's
                              original filename, or edited name, Example
                              Response: test-2021-01-01.png)
                            </li>
                            <li>
                              <b>[url]</b> (The direct URL to the attachment,
                              Example Response:
                              {{
                                this.$store.state.site.hostnameWithProtocol
                              }}/i/2327417e.png)
                            </li>
                            <li>
                              <b>[attachment.fileSize]</b> (The filesize of the
                              attachment in bytes, Example Response: 1024)
                            </li>
                            <li>
                              <b>[attachment.fileSizeFriendly]</b> (The filesize
                              of the attachment in a friendly, readable format,
                              Example Response: 1.0KB)
                            </li>
                            <li>
                              <b>[attachment.createdAt]</b> (The date the file
                              was uploaded, Example Response: Fri Aug 27 2021
                              21:02:12 GMT+1000 (Australian Eastern Standard
                              Time))
                            </li>
                            <li>
                              <b>[attachment.createdAtFriendly]</b> (The date
                              the file was uploaded in a friendly, readable
                              format, Example Response: 9:02PM, 27th of August
                              2021)
                            </li>
                          </ul>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <br />
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.openGraphTitle"
                      :outlined="!$store.state.site.whitelabel"
                      label="Open Graph Title"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.openGraphDescription"
                      :outlined="!$store.state.site.whitelabel"
                      label="Open Graph Description"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.openGraphSiteName"
                      :outlined="!$store.state.site.whitelabel"
                      label="Open Graph Site Name"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.openGraphSiteURL"
                      :outlined="!$store.state.site.whitelabel"
                      label="Open Graph Site URL"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.oEmbedAuthorName"
                      :outlined="!$store.state.site.whitelabel"
                      label="oEmbed Author Name"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="customization.oEmbedAuthorURL"
                      :outlined="!$store.state.site.whitelabel"
                      label="oEmbed Author URL"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-text-field>
                    <p>Open Graph Color:</p>
                    <v-checkbox
                      v-model="customization.openGraphRandomColor"
                      label="Random Color"
                    ></v-checkbox>
                    <v-color-picker
                      v-model="customization.openGraphColor"
                      :disabled="customization.openGraphRandomColor"
                      dot-size="25"
                      hide-mode-switch
                      mode="hexa"
                      swatches-max-height="200"
                      @change="
                        calculatePreview(
                          customization.fakeData,
                          customization.embedPreview
                        )
                      "
                    ></v-color-picker>
                    <br />
                    <v-btn
                      class="rounded-xl"
                      :loading="customization.loading"
                      @click="changeOpenGraph()"
                      >Save Settings
                    </v-btn>
                  </v-col>
                  <v-col>
                    <p class="text-h5">Discord Link Preview</p>
                    <a>{{ customization.embedPreview.url }}</a>
                    <div
                      :class="{ sticky: !$vuetify.breakpoint.mobile }"
                      class="wrapper"
                    >
                      <div
                        :style="'background-color:' + calculateColor()"
                        class="side-colored"
                      ></div>
                      <div class="card embed">
                        <div class="card-block">
                          <div class="embed-inner">
                            <div class="embed-site-name">
                              <a
                                :href="customization.openGraphSiteURL"
                                style="text-decoration: none; color: inherit"
                                >{{
                                  customization.embedPreview.openGraphSiteName
                                }}</a
                              >
                            </div>
                            <div class="embed-author-name">
                              <a
                                :href="customization.oEmbedAuthorURL"
                                style="
                                  text-decoration: none;
                                  color: inherit;
                                  font-weight: 500;
                                "
                                >{{
                                  customization.embedPreview.oEmbedAuthorName
                                }}</a
                              >
                            </div>
                            <div class="embed-title">
                              <a style="color: inherit">{{
                                customization.embedPreview.openGraphTitle
                              }}</a>
                            </div>
                            <div class="embed-description">
                              <p>
                                {{
                                  customization.embedPreview
                                    .openGraphDescription
                                }}
                              </p>
                            </div>
                            <img
                              class="embed-thumb"
                              src="https://i.troplo.com/i/a050d6f271c3.png"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-tab-item>
          <v-tab-item> <SettingsTheme></SettingsTheme> </v-tab-item>
          <v-tab-item v-if="$vuetify.breakpoint.mdAndUp">
            <div class="container text-center justify-center">
              <v-row>
                <v-col md="3">
                  <v-card
                    @click="changeNavigation('sidebar')"
                    :disabled="$store.state.navigation === 'sidebar'"
                    class="rounded-xl d-flex flex-column"
                    elevation="8"
                  >
                    <v-toolbar>
                      <v-toolbar-title>Sidebar</v-toolbar-title>
                    </v-toolbar>
                    <v-img
                      src="../assets/images/sidebar.png"
                      contain
                      height="220"
                    ></v-img>
                  </v-card>
                </v-col>
                <v-col md="3">
                  <v-card
                    @click="changeNavigation('navbar')"
                    :disabled="$store.state.navigation === 'navbar'"
                    class="rounded-xl d-flex flex-column"
                    elevation="8"
                  >
                    <v-toolbar>
                      <v-toolbar-title>Navigation bar</v-toolbar-title>
                    </v-toolbar>
                    <v-img
                      src="../assets/images/navbar.png"
                      contain
                      height="220"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="container">
              <v-card-title>API Key Options</v-card-title>
              <v-autocomplete
                v-model="apiKeys.selected"
                :items="apiKeys.items"
                item-value="token"
                item-text="name"
                class="mx-3"
                placeholder="Select an API Key"
                label="Select an API Key"
              >
              </v-autocomplete>
              <v-card-actions>
                <v-chip
                  class="mr-2"
                  color="teal"
                  text-color="white"
                  @click="copyAddress(apiKeys.selected)"
                  :disabled="!apiKeys.selected"
                >
                  <v-icon left> mdi-content-copy</v-icon>
                  Copy API Key
                </v-chip>
                <v-chip
                  class="mr-2"
                  color="indigo"
                  text-color="white"
                  @click="saveFile()"
                  :disabled="!apiKeys.selected"
                >
                  <v-icon left> mdi-download</v-icon>
                  Download ShareX Config
                </v-chip>
                <v-chip
                  class="mr-2"
                  color="deep-purple"
                  text-color="white"
                  @click="saveFileShareNix()"
                  :disabled="!apiKeys.selected"
                >
                  <v-icon left> mdi-download</v-icon>
                  Download ShareNix Config
                </v-chip>
                <v-chip
                  class="mr-2"
                  color="#78C257"
                  text-color="white"
                  href="https://i.troplo.com/i/4b46dcfa13f1.flo"
                >
                  <v-icon left> mdi-android</v-icon>
                  Download Automate Config
                </v-chip>
              </v-card-actions>
              <v-card-title>Legacy API Key Options</v-card-title>
              <v-alert text type="error">
                Legacy API Keys are no longer available from 4/11/2022.<br />
                Please create a new API key in the API Keys tab, and re-download
                (or update) your ShareX config.
              </v-alert>
              <v-card-title
                >How to install the ShareX configuration:
              </v-card-title>
              <v-container>
                <video controls height="430" muted>
                  <source
                    src="https://i.troplo.com/i/ddedf216ef3a.mp4"
                    type="video/mp4"
                  />
                </video>
              </v-container>
              <v-card-title
                >How to install the ShareNix configuration:
              </v-card-title>
              <v-container>
                <ol>
                  <li>Download and install ShareNix for your distribution.</li>
                  <li>
                    Download and install Flameshot or another supported
                    screenshot tool.
                  </li>
                  <li>Download the ShareNix config.</li>
                  <li>
                    Move the downloaded config to ~/.sharenix.json, example:
                    <code
                      >mv "{{ $store.state.user.username }} - TPU.json"
                      ~/.sharenix.json</code
                    >
                  </li>
                  <li>
                    Run <code>sharenix {file}</code> or
                    <code>sharenix-section</code> (for a screenshot) to upload a
                    file to TPU.
                  </li>
                </ol>
              </v-container>
              <v-card-title
                >How to install the Automate config for Android devices:
              </v-card-title>
              <v-container>
                <ol>
                  <li>
                    Download the Automate app from the Google Play Store
                    <a
                      href="https://play.google.com/store/apps/details?id=com.llamalab.automate"
                      >here</a
                    >.
                  </li>
                  <li>Download the Automate .flo config from TPU.</li>
                  <li>
                    From the 3 dots on the top right hand corner, press the
                    "Import" button and import the .flo file using the file
                    manager.
                  </li>
                  <li>
                    Select the imported TPU flow, and hit the "Edit" icon
                    floating action button, and then the graph icon.
                  </li>
                  <li>
                    Modify the 3 top block variables collectionId, apiKey, path
                    to your liking, collectionId may be null, this will send an
                    additional network request to add any uploads to a
                    collection from your device.
                  </li>
                  <li>
                    Start the flow, and enable the option to start flows at
                    system boot in the app settings if you'd like.
                  </li>
                  <small
                    >Android 12 or lower is recommended. Android 13 may display
                    a notification when an item has been newly copied to the
                    clipboard, you may want to disable the auto clipboard copy
                    block in this case.</small
                  >
                </ol>
              </v-container>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-toolbar color="toolbar" class="rounded-xl">
                <v-toolbar-title>API Keys</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="apiKeys.add.dialog = true" text>
                  <v-icon left>mdi-plus</v-icon>
                  Add API Key
                </v-btn>
              </v-toolbar>
              <v-data-table
                :headers="apiKeys.headers"
                :items="apiKeys.items"
                class="elevation-1"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="copyAddress(item.token)"
                    >mdi-content-copy</v-icon
                  >
                  <v-icon small class="mr-2" @click="deleteApiKey(item.id)"
                    >mdi-delete</v-icon
                  >
                </template>
              </v-data-table>
              <v-divider
                class="mb-1"
                v-if="
                  $store.state.user.flowinityId || $store.state.user.discordId
                "
              ></v-divider>
              <p
                class="text-h4 mb-n4"
                v-if="
                  $store.state.user.flowinityId || $store.state.user.discordId
                "
              >
                Connections
              </p>
            </v-container>
            <v-container
              v-if="
                !$store.state.user.flowinityId &&
                $store.state.experiments['LEGACY_FLOWINITY_SSO']
              "
            >
              <p class="text-h5">Flowinity SSO</p>
              <p>
                Flowinity SSO is enforced on this instance, please link it here.
              </p>
              <v-chip
                :href="
                  'https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=' +
                  $store.state.site.flowinityId +
                  '&redirect_uri=' +
                  $store.state.site.hostnameWithProtocol +
                  '%2FflowinityAuthorize%2Flink&response_type=code'
                "
                color="indigo"
                text-color="white"
              >
                Link Account
              </v-chip>
            </v-container>
            <v-container v-if="$store.state.user.flowinityId">
              <p class="text-h5">Flowinity SSO</p>
              <p>Your Flowinity SSO account has been linked.</p>
              <p>Your ID is: {{ $store.state.user.flowinityId }}</p>
            </v-container>
            <v-container v-if="$store.state.user.discordId">
              <p class="text-h4">Discord</p>
              <p>Your Discord account has been linked.</p>
              <p>
                You're logged in as:
                {{ $store.state.user.discordUserCache.username }}#{{
                  $store.state.user.discordUserCache.discriminator
                }}
              </p>
              <v-card-actions>
                <v-btn
                  class="rounded-xl"
                  :loading="externalAccounts.discord.guildRoleLoading"
                  @click="guildRoleRefresh"
                >
                  Refresh roles in guild
                </v-btn>
                <v-btn
                  class="rounded-xl"
                  :loading="externalAccounts.discord.discordUnlinkLoading"
                  @click="unlinkDiscord"
                >
                  Unlink Discord
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="false">
            <v-container>
              <p class="text-h4">Plan</p>
              <v-alert :type="calculateType()">
                <p class="title">{{ $store.state.user.plan.name }}</p>
                <p
                  v-if="$store.state.user.subscription.cancelled"
                  class="subtitle-1"
                >
                  Your subscription has been cancelled and will end on
                  {{
                    dayjs($store.state.user.subscription.expiredAt).format(
                      "Do of MMMM YYYY, h:mm A"
                    )
                  }}.
                </p>
                <p
                  v-if="
                    $store.state.user.plan.internalName !== 'FREE' &&
                    !$store.state.user.subscription.cancelled
                  "
                >
                  If you don't have enough credits left, your account will be
                  automatically downgraded to free.
                </p>
                <p
                  v-if="
                    $store.state.user.plan.internalName !== 'FREE' &&
                    !$store.state.user.subscription.cancelled
                  "
                >
                  {{
                    calculateCost($store.state.user.plan.price).toLocaleString(
                      "en-US",
                      { style: "currency", currency: "USD" }
                    )
                  }}
                  will automatically be deducted from your account each month
                  until cancelled on
                  {{
                    dayjs($store.state.user.subscription.expiredAt).format(
                      "Do of MMMM YYYY, h:mm A"
                    )
                  }}.
                </p>
                <p>
                  Enjoy the following benefits of
                  {{ $store.state.user.plan.name }}:
                </p>
                <ul
                  v-for="feature in $store.state.user.plan.features"
                  :key="feature"
                >
                  <li>
                    {{ feature }}
                  </li>
                </ul>
                <v-card-actions>
                  <v-btn
                    class="rounded-xl"
                    v-if="
                      $store.state.user.plan.internalName !== 'FREE' &&
                      $store.state.user.subscription.cancelled
                    "
                    :loading="credits.cancelLoading"
                    @click="cancelPlan()"
                    >Re-activate
                  </v-btn>
                  <v-btn
                    class="rounded-xl"
                    v-if="
                      $store.state.user.plan.internalName !== 'FREE' &&
                      !$store.state.user.subscription.cancelled
                    "
                    :loading="credits.cancelLoading"
                    @click="cancelPlan()"
                    >Cancel
                  </v-btn>
                  <v-btn class="rounded-xl" @click="$router.push('/plans')"
                    >See available plans
                  </v-btn>
                </v-card-actions>
              </v-alert>
              <p class="text-h4">Credits</p>
              <p>
                You currently have
                {{
                  calculateCost($store.state.user.credits).toLocaleString(
                    "en-US",
                    { style: "currency", currency: "USD" }
                  )
                }}
                in your {{ $store.state.site.name }} account, credits are used
                for subscription purchasing and renewing.
              </p>
              <p>
                Credits can only be purchased via cryptocurrency at this time.
              </p>
              <v-card-actions>
                <v-btn class="rounded-xl" @click="credits.dialog = true"
                  >Add Credits</v-btn
                >
              </v-card-actions>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="false">
            <v-container v-if="bio.loading">
              <v-card class="rounded-xl" elevation="7">
                <v-container class="text-center">
                  <p class="text-lg-h4">Loading...</p>
                </v-container>
              </v-card>
            </v-container>
            <v-container v-if="bio.stage === 1 && !bio.loading">
              <v-container class="justify-center align-center text-center">
                <p class="text-h3 justify-center">Pages</p>
                <p class="text-h5 justify-center">
                  Create your own personalized portfolio.
                </p>
                <v-text-field
                  v-model="bio.create.name"
                  :outlined="!$store.state.site.whitelabel"
                  :placeholder="$store.state.user.username + '9999'"
                  class="bio-input justify-center rounded-xl"
                  label="Path"
                ></v-text-field>
                <v-btn
                  class="rounded-xl"
                  :loading="bio.create.loading"
                  @click="createBio"
                  >Create Now
                </v-btn>
              </v-container>
            </v-container>
            <v-container v-if="bio.stage === 2 && !bio.loading">
              <div>
                <p class="text-h5">Page Settings</p>
                <p>
                  Your page is accessible at
                  <router-link :to="'/p/' + bio.settings.bio.route"
                    >{{ $store.state.site.hostnameWithProtocol }}/p/{{
                      bio.settings.bio.route
                    }}
                  </router-link>
                </p>
                <v-form>
                  <v-file-input
                    v-model="bio.settings.avatar.file"
                    :outlined="!$store.state.site.whitelabel"
                    :rules="bio.settings.avatar.rules"
                    accept="image/png, image/jpeg"
                    label="Background"
                    placeholder="Pick a background"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                  <v-card-actions>
                    <v-btn
                      class="rounded-xl"
                      :loading="bio.settings.avatar.loading"
                      @click="changeBackground"
                      >Upload Background
                    </v-btn>
                    <v-btn
                      class="rounded-xl"
                      :loading="bio.settings.avatar.loadingRemove"
                      @click="removeBackground"
                      >Remove Background
                    </v-btn>
                  </v-card-actions>
                  <v-divider class="mt-2"></v-divider>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.title"
                    :outlined="!$store.state.site.whitelabel"
                    label="Title"
                    maxlength="25"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.subtitle"
                    :outlined="!$store.state.site.whitelabel"
                    label="Subtitle"
                    maxlength="40"
                  >
                  </v-text-field>
                  <v-textarea
                    v-model="bio.settings.bio.pageData.page.content"
                    :outlined="!$store.state.site.whitelabel"
                    label="Content"
                    maxlength="400"
                  >
                  </v-textarea>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.twitter"
                    :outlined="!$store.state.site.whitelabel"
                    label="Twitter"
                    placeholder="TheTroplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.facebook"
                    :outlined="!$store.state.site.whitelabel"
                    label="Facebook"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.matrix"
                    :outlined="!$store.state.site.whitelabel"
                    label="Matrix"
                    placeholder="@troplo:troplo.com"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.youtube"
                    :outlined="!$store.state.site.whitelabel"
                    label="YouTube"
                    placeholder="UCzoqM3bfFGK9AVliaNE9sOg"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.website"
                    :outlined="!$store.state.site.whitelabel"
                    label="Website"
                    placeholder="https://troplo.com"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.linkedIn"
                    :outlined="!$store.state.site.whitelabel"
                    label="LinkedIn"
                    placeholder="troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.twitch"
                    :outlined="!$store.state.site.whitelabel"
                    label="Twitch"
                    placeholder="thetroplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.discord"
                    :outlined="!$store.state.site.whitelabel"
                    label="Discord"
                    maxlength="20"
                    placeholder="Troplo#8495"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.instagram"
                    :outlined="!$store.state.site.whitelabel"
                    label="Instagram"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.github"
                    :outlined="!$store.state.site.whitelabel"
                    label="GitHub (Hosted)"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.gitlab"
                    :outlined="!$store.state.site.whitelabel"
                    label="GitLab (Hosted)"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.bitbucket"
                    :outlined="!$store.state.site.whitelabel"
                    label="BitBucket (Hosted)"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.gitea"
                    :outlined="!$store.state.site.whitelabel"
                    label="Gitea (Self Hosted)"
                    placeholder="https://git.troplo.com/Troplo"
                  >
                  </v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="bio.settings.bio.pageData.page.social.telegram"
                    :outlined="!$store.state.site.whitelabel"
                    label="Telegram"
                    placeholder="Troplo"
                  >
                  </v-text-field>
                  <v-btn
                    class="rounded-xl"
                    :loading="bio.settings.loading"
                    @click="updateBio"
                    >Update Bio
                  </v-btn>
                </v-form>
              </div>
              <br />
              <p class="text-h5">Preview (without background):</p>
              <v-card
                id="userCard"
                align="stretch"
                class="rounded-xl transparent"
                elevation="7"
              >
                <v-row>
                  <v-col cols="1" md="4" sm="1">
                    <v-container>
                      <div class="justify-center">
                        <router-link
                          style="cursor: pointer; color: #2086ff"
                          tag="small"
                          to="/"
                        >
                          <v-icon color="#2086ff" small>mdi-arrow-left </v-icon>
                          Back to {{ $store.state.site.name }}
                        </router-link>
                        <center>
                          <v-avatar
                            v-if="bio.settings.bio.user.avatar"
                            :src="'/i/' + bio.settings.bio.user.avatar"
                            align="center"
                            class="text-center"
                            justify="center"
                            size="220"
                          >
                            <img
                              v-if="bio.settings.bio.user.avatar"
                              :src="'/i/' + bio.settings.bio.user.avatar"
                            />
                          </v-avatar>
                          <v-avatar
                            v-if="!bio.settings.bio.user.avatar"
                            :src="
                              '/api/v1/userutils/identicon/' +
                              bio.settings.bio.user.username
                            "
                            align="center"
                            class="text-center justify-center"
                            justify="center"
                            size="220"
                          >
                            <img
                              v-if="!bio.settings.bio.user.avatar"
                              :src="
                                '/api/v1/userutils/identicon/' +
                                bio.settings.bio.user.username
                              "
                            />
                          </v-avatar>
                          <p class="text-h6">
                            &nbsp;
                            {{ bio.settings.bio.pageData.page.title }}
                          </p>
                          <p>
                            {{ bio.settings.bio.pageData.page.subtitle }}
                          </p>
                          <v-icon> mdi-eye</v-icon>
                          {{ bio.settings.bio.views }}
                        </center>
                      </div>
                    </v-container>
                  </v-col>
                  <v-col>
                    <div class="text-block" style="white-space: pre-line">
                      <v-container>
                        <p class="text-h6">About Me:</p>
                        <p>{{ bio.settings.bio.pageData.page.content }}</p>
                        <v-chip-group column>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.twitter"
                            :href="
                              'https://twitter.com/' +
                              bio.settings.bio.pageData.page.social.twitter
                            "
                            class="ma-2"
                            color="#1DA1F2"
                          >
                            <v-icon> mdi-twitter</v-icon>&nbsp; Twitter
                          </v-chip>
                          <v-chip
                            v-if="
                              bio.settings.bio.pageData.page.social.facebook
                            "
                            :href="
                              'https://facebook.com/' +
                              bio.settings.bio.pageData.page.social.facebook
                            "
                            class="ma-2"
                            color="#4267B2"
                          >
                            <v-icon> mdi-facebook</v-icon>&nbsp; Facebook
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.matrix"
                            :href="
                              'https://matrix.to/#/' +
                              bio.settings.bio.pageData.page.social.matrix
                            "
                            class="ma-2"
                            color="#fffff"
                          >
                            <v-icon> mdi-matrix</v-icon>&nbsp; Matrix
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.youtube"
                            :href="
                              'https://youtube.com/channel/' +
                              bio.settings.bio.pageData.page.social.youtube
                            "
                            class="ma-2"
                            color="#c4302b"
                          >
                            <v-icon> mdi-youtube</v-icon>&nbsp; YouTube
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.website"
                            :href="
                              bio.settings.bio.pageData.page.social.website
                            "
                            class="ma-2"
                            color="primary"
                          >
                            <v-icon> mdi-earth</v-icon>&nbsp; Website
                          </v-chip>
                          <v-chip
                            v-if="
                              bio.settings.bio.pageData.page.social.telegram
                            "
                            :href="
                              'https://t.me/' +
                              bio.settings.bio.pageData.page.social.telegram
                            "
                            class="ma-2"
                            color="#0088cc"
                          >
                            <v-icon> mdi-send</v-icon>&nbsp; Telegram
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.teams"
                            :href="bio.settings.bio.pageData.page.social.teams"
                            class="ma-2"
                            color="#464EB8"
                          >
                            <v-icon> mdi-microsoft-teams</v-icon>&nbsp; Teams
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.discord"
                            class="ma-2"
                            color="#5865F2"
                            @click="
                              copy(settings.bio.pageData.page.social.discord)
                            "
                          >
                            <v-icon> mdi-discord</v-icon>&nbsp;
                            {{ bio.settings.bio.pageData.page.social.discord }}
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.myspace"
                            :href="
                              'https://myspace.com/' +
                              bio.settings.bio.pageData.page.social.myspace
                            "
                            class="ma-2"
                            color="#1DA1F2"
                          >
                            <v-icon> mdi-myspace</v-icon>&nbsp; MySpace
                          </v-chip>
                          <v-chip
                            v-if="
                              bio.settings.bio.pageData.page.social.linkedIn
                            "
                            :href="
                              'https://linkedin.com/in/' +
                              bio.settings.bio.pageData.page.social.linkedIn
                            "
                            class="ma-2"
                            color="#0077B5"
                          >
                            <v-icon> mdi-linkedin</v-icon>&nbsp; LinkedIn
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.twitch"
                            :href="
                              'https://twitch.tv/' +
                              bio.settings.bio.pageData.page.social.twitch
                            "
                            class="ma-2"
                            color="#6441A5"
                          >
                            <v-icon> mdi-twitch</v-icon>&nbsp; Twitch
                          </v-chip>
                          <v-chip
                            v-if="
                              bio.settings.bio.pageData.page.social.instagram
                            "
                            :href="
                              'https://instagram.com/' +
                              bio.settings.bio.pageData.page.social.instagram
                            "
                            class="ma-2"
                            color="#DD2A7B"
                          >
                            <v-icon> mdi-instagram</v-icon>&nbsp; Instagram
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.github"
                            :href="
                              'https://github.com/' +
                              bio.settings.bio.pageData.page.social.github
                            "
                            class="ma-2"
                            color="white"
                            text-color="black"
                          >
                            <v-icon> mdi-github</v-icon>&nbsp; GitHub
                          </v-chip>
                          <v-chip
                            v-if="
                              bio.settings.bio.pageData.page.social.bitbucket
                            "
                            :href="
                              'https://bitbucket.com/' +
                              bio.settings.bio.pageData.page.social.bitbucket
                            "
                            class="ma-2"
                            color="#1A74ED"
                          >
                            <v-icon> mdi-bitbucket</v-icon>&nbsp; BitBucket
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.gitlab"
                            :href="
                              'https://gitlab.com/' +
                              bio.settings.bio.pageData.page.social.gitlab
                            "
                            class="ma-2"
                            color="#E2432A"
                          >
                            <v-icon> mdi-gitlab</v-icon>&nbsp; GitLab
                          </v-chip>
                          <v-chip
                            v-if="bio.settings.bio.pageData.page.social.gitea"
                            :href="bio.settings.bio.pageData.page.social.gitea"
                            class="ma-2"
                            color="#6ba035"
                          >
                            <v-icon> mdi-tea</v-icon>&nbsp; Gitea
                          </v-chip>
                        </v-chip-group>
                      </v-container>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <br />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <SettingsSlideshow></SettingsSlideshow>
          </v-tab-item>
          <v-tab-item>
            <v-container class="text-center">
              <p class="text-h4">
                <span
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                  >{{ $store.state.site.name }}</span
                >
              </p>
              <p>
                Release: {{ calculateRelease() }}<br />
                Frontend Build Version: {{ $store.state.versioning.version
                }}<br />
                Frontend Build Date: {{ $store.state.versioning.date }}
              </p>
              <h1
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Site Experiments & Attributes
              </h1>
              <!-- v-for all $store.state.attributes with the title being the key of the attribute -->
              <template v-if="$store.state.experiments['LEGACY_ATTRIBUTES_UI']">
                <div
                  v-for="(value, key) in $store.state.attributes"
                  :key="key"
                  class="text-center justify-center"
                >
                  <h2>{{ key }}</h2>
                  <center>
                    <v-text-field
                      v-for="(value, key1) in value"
                      :key="key1"
                      :label="key1"
                      v-model="$store.state.attributes[key][key1]"
                      style="width: 20%"
                      class="centered-input"
                    ></v-text-field>
                  </center>
                </div>
                <v-btn color="info" text @click="saveAttributes">
                  Save custom site attributes </v-btn
                ><br />
                <v-btn color="red" text @click="resetAttributes">
                  Reset custom site attributes
                </v-btn>
              </template>
              <template v-else>
                <router-link to="/experiments" style="text-decoration: none">
                  <v-icon color="blue" size="25">mdi-arrow-right</v-icon> Go to
                  experiments
                </router-link>
              </template>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
//import VueQrcode from "@chenfengyuan/vue-qrcode"
import dayjs from "dayjs"
import SettingsTheme from "@/components/SettingsTheme"
import SettingsSlideshow from "@/components/SettingsSlideshow"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Settings",
  components: {
    //VueQrcode,
    SettingsTheme,
    SettingsSlideshow
  },
  data() {
    return {
      apiKeys: {
        selected: "",
        add: {
          dialog: false,
          name: "",
          key: "",
          expiry: "",
          scopes: ["uploads.create", "user.view"],
          availableScopes: [
            {
              name: "Uploads",
              id: "uploads",
              children: [
                {
                  name: "Uploads (Modify)",
                  id: "uploads.modify"
                },
                {
                  name: "Upload (Create)",
                  id: "uploads.create"
                },
                {
                  name: "Uploads (View)",
                  id: "uploads.view"
                }
              ]
            },
            {
              name: "User",
              id: "user",
              children: [
                {
                  name: "View UserInfo",
                  id: "user.view"
                },
                {
                  name: "User (Modify)",
                  id: "user.modify"
                }
              ]
            },
            {
              name: "Collections",
              id: "collections",
              children: [
                {
                  name: "Collections (Modify)",
                  id: "collections.modify"
                },
                {
                  name: "Collections (Create)",
                  id: "collections.create"
                },
                {
                  name: "Collections (View)",
                  id: "collections.view"
                }
              ]
            }
          ]
        },
        headers: [
          {
            text: "Name",
            value: "name"
          },
          {
            text: "Scopes",
            value: "scopes"
          },
          {
            text: "Expiry",
            value: "expiry"
          },
          {
            text: "Created At",
            value: "createdAt"
          },
          { text: "Actions", value: "actions", sortable: false }
        ],
        items: []
      },
      panel: false,
      tab: 1,
      bio: {
        stage: 0,
        create: {
          name: "",
          loading: false
        },
        settings: {
          avatar: {
            file: [],
            loading: false,
            loadingRemove: false,
            rules: [
              (value) =>
                !value ||
                value.size < 8000000 ||
                "Background size should be less than 8 MB!"
            ]
          },
          bio: {},
          loading: false
        },
        loading: false
      },
      credits: {
        selectedCrypto: null,
        stage: 1,
        response: [],
        dialog: false,
        loading: false,
        cancelLoading: false,
        amount: 0
      },
      privacy: {
        usernameHidden: false,
        loading: false,
        discordPrecache: false
      },
      wipeGallery: {
        automated: {
          time: 0,
          currentPassword: "",
          loading: false,
          selected: "disabled",
          items: [
            {
              internalName: "disabled",
              name: "Disabled"
            },
            {
              internalName: "fileAge",
              name: "File Age"
            },
            {
              internalName: "interval",
              name: "Interval"
            }
          ]
        },
        loading: false,
        currentPassword: ""
      },
      totp: {
        loading: false,
        stage: 0,
        currentPassword: "",
        validate: {
          token: "",
          url: "",
          loading: false,
          code: null
        },
        disable: {
          currentPassword: "",
          loading: false,
          code: ""
        }
      },
      avatar: {
        file: [],
        loading: false,
        loadingRemove: false,
        rules: [
          (value) =>
            !value ||
            value.size < 2000000 ||
            "Avatar size should be less than 2 MB!"
        ]
      },
      username: {
        username: "",
        password: "",
        loading: false
      },
      email: {
        email: "",
        password: "",
        loading: false
      },
      password: {
        password: "",
        currentPassword: "",
        confirmPassword: "",
        loading: false
      },
      description: {
        description: "",
        loading: false
      },
      deleteAccount: {
        currentPassword: "",
        loading: false
      },
      customization: {
        fakeData: {
          id: 227,
          attachment: "751a3287.txt",
          UserId: 6,
          name: "Test.txt",
          originalFilename: "Test.txt",
          type: "text",
          urlRedirect: null,
          fileSize: 23,
          deletable: true,
          folderId: null,
          path: null,
          createdAt: "2021-10-12T10:02:38.000Z",
          updatedAt: "2021-10-12T10:02:38.000Z",
          FolderId: null,
          User: {
            id: 6,
            username: "Troplo",
            description: "enableTroploThemeOverride",
            avatar: "b626dc4c.png",
            uploadNameHidden: false,
            invisibleURLs: true,
            openGraphRandomColor: false,
            customPath: "/",
            createdAt: "2021-08-08T11:39:29.000Z",
            updatedAt: "2021-10-21T10:58:30.000Z"
          }
        },
        embedPreview: {
          openGraph: true,
          openGraphColor: "",
          openGraphSiteURL: "",
          openGraphSiteName: "",
          openGraphAuthorURL: "",
          openGraphAuthor: "",
          openGraphTitle: "",
          openGraphDescription: "",
          openGraphCustomFields: {},
          oEmbedAuthorName: "",
          oEmbedAuthorURL: "",
          url: ""
        },
        openGraph: true,
        openGraphColor: "",
        openGraphSiteURL: "",
        openGraphSiteName: "",
        openGraphAuthorURL: "",
        openGraphAuthor: "",
        openGraphTitle: "",
        openGraphDescription: "",
        openGraphCustomFields: {},
        oEmbedAuthorName: "",
        oEmbedAuthorURL: "",
        loading: false,
        invisibleURLs: false,
        loadingOther: false,
        openGraphRandomColor: false,
        customPath: "/",
        fakePath: false,
        fakePathValue: ""
      },
      externalAccounts: {
        discord: {
          showOnProfile: true,
          guildRoleLoading: false,
          saveLoading: false,
          discordUnlinkLoading: false
        }
      },
      discordUserCache: null,
      interval: null
    }
  },
  computed: {},
  methods: {
    addApiKey() {
      this.apiKeys.loading = true
      this.axios
        .post("/api/v1/userutils/apiKey", {
          name: this.apiKeys.add.name,
          scopes: this.apiKeys.add.scopes,
          expiry: this.apiKeys.add.expiry
        })
        .then((res) => {
          this.apiKeys.add.key = res.data.token
          this.apiKeys.loading = false
          this.getApiKeys()
        })
    },
    getApiKeys() {
      this.apiKeys.loading = true
      this.axios.get("/api/v1/userutils/apiKey").then((res) => {
        this.apiKeys.items = res.data
        this.apiKeys.loading = false
      })
    },
    deleteApiKey(id) {
      this.apiKeys.loading = true
      this.axios.delete("/api/v1/userutils/apiKey/" + id).then(() => {
        this.getApiKeys()
      })
    },
    saveAttributes() {
      for (const [key, value] of Object.entries(this.$store.state.attributes)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (value2 === "true") {
            this.$store.state.attributes[key][key2] = true
          } else if (value2 === "false") {
            this.$store.state.attributes[key][key2] = false
          }
        }
      }
      localStorage.setItem(
        "attributes",
        JSON.stringify(this.$store.state.attributes)
      )
    },
    resetAttributes() {
      localStorage.removeItem("attributes")
      this.$store.state.attributes = this.$store.state.defaultAttributes
    },
    changeNavigation(item) {
      localStorage.removeItem("navigation")
      localStorage.setItem("navigation", item)
      this.$store.commit("updateNavigation", item)
    },
    createBio() {
      this.bio.create.loading = true
      this.axios
        .post("/api/v1/bios/create", {
          route: this.bio.create.name
        })
        .then(() => {
          this.getBio()
          this.$toast("Your page has been created.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.bio.create.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeBackground() {
      this.bio.settings.avatar.loading = true
      const data = new FormData()
      data.append("attachment", this.bio.settings.avatar.file)
      this.axios
        .post("/api/v1/bios/edit/background", data)
        .then(() => {
          this.bio.settings.avatar.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.bio.settings.avatar.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    removeBackground() {
      this.bio.settings.avatar.loadingRemove = true
      this.axios
        .put("/api/v1/bios/edit/background/remove")
        .then(() => {
          this.bio.settings.avatar.loadingRemove = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.bio.settings.avatar.loadingRemove = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    updateBio() {
      this.bio.settings.loading = true
      this.axios
        .put("/api/v1/bios/edit", {
          pageData: this.bio.settings.bio.pageData
        })
        .then(() => {
          this.bio.settings.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.bio.settings.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getBio() {
      this.loading = true
      this.axios
        .get("/api/v1/bios/get")
        .then((res) => {
          this.bio.settings.bio = res.data
          this.bio.settings.bio.pageData = res.data.pageData
          this.bio.loading = false
          this.bio.stage = 2
        })
        .catch(() => {
          this.bio.stage = 1
          this.loading = false
        })
    },
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    calculatePreview(upload, to) {
      try {
        const openGraphDescriptionUserUsername =
          this.customization.openGraphDescription
            .toString()
            .split("[user.username]")
            .join(this.$store.state.user.username)
        const openGraphDescriptionUserId = openGraphDescriptionUserUsername
          .toString()
          .split("[user.id]")
          .join(this.$store.state.user.id)
        const openGraphDescriptionAttachmentId = openGraphDescriptionUserId
          .toString()
          .split("[attachment.id]")
          .join(upload.id)
        const openGraphDescriptionAttachmentName =
          openGraphDescriptionAttachmentId
            .toString()
            .split("[attachment.name]")
            .join(upload.name)
        const openGraphDescriptionAttachmentAttachment =
          openGraphDescriptionAttachmentName
            .toString()
            .split("[attachment.fileName]")
            .join(upload.attachment)
        const openGraphDescriptionUrl = openGraphDescriptionAttachmentAttachment
          .toString()
          .split("[url]")
          .join(`${process.env.HOSTNAME_WITH_PROTOCOL}/i/` + upload.attachment)
        const openGraphDescriptionFileSize = openGraphDescriptionUrl
          .toString()
          .split("[attachment.fileSize]")
          .join(upload.fileSize)
        const openGraphDescriptionFileSizeFriendly =
          openGraphDescriptionFileSize
            .toString()
            .split("[attachment.fileSizeFriendly]")
            .join(this.fileSize(upload.fileSize))
        const openGraphDescriptionCreatedAt =
          openGraphDescriptionFileSizeFriendly
            .toString()
            .split("[attachment.createdAt]")
            .join(upload.createdAt)
        to.openGraphDescription = openGraphDescriptionCreatedAt
          .toString()
          .split("[attachment.createdAtFriendly]")
          .join(dayjs(upload.createdAt).format("Do of MMMM YYYY, h:mm A"))
      } catch {
        to.openGraphDescription = ""
      }

      try {
        const openGraphTitleUserUsername = this.customization.openGraphTitle
          .toString()
          .split("[user.username]")
          .join(this.$store.state.user.username)
        const openGraphTitleUserId = openGraphTitleUserUsername
          .toString()
          .split("[user.id]")
          .join(this.$store.state.user.id)
        const openGraphTitleAttachmentId = openGraphTitleUserId
          .toString()
          .split("[attachment.id]")
          .join(upload.id)
        const openGraphTitleAttachmentName = openGraphTitleAttachmentId
          .toString()
          .split("[attachment.name]")
          .join(upload.name)
        const openGraphTitleAttachmentAttachment = openGraphTitleAttachmentName
          .toString()
          .split("[attachment.fileName]")
          .join(upload.attachment)
        const openGraphTitleUrl = openGraphTitleAttachmentAttachment
          .toString()
          .split("[url]")
          .join(`${process.env.HOSTNAME_WITH_PROTOCOL}/i/` + upload.attachment)
        const openGraphTitleFileSize = openGraphTitleUrl
          .toString()
          .split("[attachment.fileSize]")
          .join(upload.fileSize)
        const openGraphTitleFileSizeFriendly = openGraphTitleFileSize
          .toString()
          .split("[attachment.fileSizeFriendly]")
          .join(this.fileSize(upload.fileSize))
        const openGraphTitleCreatedAt = openGraphTitleFileSizeFriendly
          .toString()
          .split("[attachment.createdAt]")
          .join(upload.createdAt)
        to.openGraphTitle = openGraphTitleCreatedAt
          .toString()
          .split("[attachment.createdAtFriendly]")
          .join(dayjs(upload.createdAt).format("Do of MMMM YYYY, h:mm A"))
      } catch {
        to.openGraphTitle = ""
      }

      try {
        const openGraphSiteNameUserUsername =
          this.customization.openGraphSiteName
            .toString()
            .split("[user.username]")
            .join(this.$store.state.user.username)
        const openGraphSiteNameUserId = openGraphSiteNameUserUsername
          .toString()
          .split("[user.id]")
          .join(this.$store.state.user.id)
        const openGraphSiteNameAttachmentId = openGraphSiteNameUserId
          .toString()
          .split("[attachment.id]")
          .join(upload.id)
        const openGraphSiteNameAttachmentName = openGraphSiteNameAttachmentId
          .toString()
          .split("[attachment.name]")
          .join(upload.name)
        const openGraphSiteNameAttachmentAttachment =
          openGraphSiteNameAttachmentName
            .toString()
            .split("[attachment.fileName]")
            .join(upload.attachment)
        const openGraphSiteNameUrl = openGraphSiteNameAttachmentAttachment
          .toString()
          .split("[url]")
          .join(`${process.env.HOSTNAME_WITH_PROTOCOL}/i/` + upload.attachment)
        const openGraphSiteNameFileSize = openGraphSiteNameUrl
          .toString()
          .split("[attachment.fileSize]")
          .join(upload.fileSize)
        const openGraphSiteNameFileSizeFriendly = openGraphSiteNameFileSize
          .toString()
          .split("[attachment.fileSizeFriendly]")
          .join(this.fileSize(upload.fileSize))
        const openGraphSiteNameCreatedAt = openGraphSiteNameFileSizeFriendly
          .toString()
          .split("[attachment.createdAt]")
          .join(upload.createdAt)
        to.openGraphSiteName = openGraphSiteNameCreatedAt
          .toString()
          .split("[attachment.createdAtFriendly]")
          .join(dayjs(upload.createdAt).format("Do of MMMM YYYY, h:mm A"))
      } catch {
        to.openGraphSiteName = ""
      }

      try {
        const openGraphAuthorUserUsername = this.customization.oEmbedAuthorName
          .toString()
          .split("[user.username]")
          .join(this.$store.state.user.username)
        const openGraphAuthorUserId = openGraphAuthorUserUsername
          .toString()
          .split("[user.id]")
          .join(this.$store.state.user.id)
        const openGraphAuthorAttachmentId = openGraphAuthorUserId
          .toString()
          .split("[attachment.id]")
          .join(upload.id)
        const openGraphAuthorAttachmentName = openGraphAuthorAttachmentId
          .toString()
          .split("[attachment.name]")
          .join(upload.name)
        const openGraphAuthorAttachmentAttachment =
          openGraphAuthorAttachmentName
            .toString()
            .split("[attachment.fileName]")
            .join(upload.attachment)
        const openGraphAuthorUrl = openGraphAuthorAttachmentAttachment
          .toString()
          .split("[url]")
          .join(`${process.env.HOSTNAME_WITH_PROTOCOL}/i/` + upload.attachment)
        const openGraphAuthorFileSize = openGraphAuthorUrl
          .toString()
          .split("[attachment.fileSize]")
          .join(upload.fileSize)
        const openGraphAuthorFileSizeFriendly = openGraphAuthorFileSize
          .toString()
          .split("[attachment.fileSizeFriendly]")
          .join(this.fileSize(upload.fileSize))
        const openGraphAuthorCreatedAt = openGraphAuthorFileSizeFriendly
          .toString()
          .split("[attachment.createdAt]")
          .join(upload.createdAt)
        to.oEmbedAuthorName = openGraphAuthorCreatedAt
          .toString()
          .split("[attachment.createdAtFriendly]")
          .join(dayjs(upload.createdAt).format("Do of MMMM YYYY, h:mm A"))
      } catch {
        to.oEmbedAuthorName = ""
      }

      try {
        if (this.customization.fakePath) {
          const openGraphAuthorUserUsername = this.customization.fakePathValue
            .toString()
            .split("[user.username]")
            .join(this.$store.state.user.username)
          const openGraphAuthorUserId = openGraphAuthorUserUsername
            .toString()
            .split("[user.id]")
            .join(this.$store.state.user.id)
          const openGraphAuthorAttachmentId = openGraphAuthorUserId
            .toString()
            .split("[attachment.id]")
            .join(upload.id)
          const openGraphAuthorAttachmentName = openGraphAuthorAttachmentId
            .toString()
            .split("[attachment.name]")
            .join(upload.name)
          const openGraphAuthorAttachmentAttachment =
            openGraphAuthorAttachmentName
              .toString()
              .split("[attachment.fileName]")
              .join(upload.attachment)
          const openGraphAuthorUrl = openGraphAuthorAttachmentAttachment
            .toString()
            .split("[url]")
            .join(
              `${process.env.HOSTNAME_WITH_PROTOCOL}/i/` + upload.attachment
            )
          const openGraphAuthorFileSize = openGraphAuthorUrl
            .toString()
            .split("[attachment.fileSize]")
            .join(upload.fileSize)
          const openGraphAuthorFileSizeFriendly = openGraphAuthorFileSize
            .toString()
            .split("[attachment.fileSizeFriendly]")
            .join(this.fileSize(upload.fileSize))
          const openGraphAuthorCreatedAt = openGraphAuthorFileSizeFriendly
            .toString()
            .split("[attachment.createdAt]")
            .join(upload.createdAt)
          to.url = openGraphAuthorCreatedAt
            .toString()
            .split("[attachment.createdAtFriendly]")
            .join(dayjs(upload.createdAt).format("Do of MMMM YYYY, h:mm A"))
        } else if (
          this.customization.invisibleURLs &&
          !this.customization.openGraph
        ) {
          to.url = "https://" + this.$store.state.user.domain.domain + "/i/"
        } else if (
          this.customization.invisibleURLs &&
          this.customization.openGraph
        ) {
          to.url = "https://" + this.$store.state.user.domain.domain
        } else if (
          !this.customization.invisibleURLs &&
          this.customization.openGraph
        ) {
          to.url =
            "https://" +
            this.$store.state.user.domain.domain +
            this.customization.customPath +
            upload.attachment
        } else {
          to.url =
            "https://" +
            this.$store.state.user.domain.domain +
            "/i/" +
            upload.attachment
        }
      } catch {
        to.url = "https://i.troplo.com/" + upload.attachment
      }
    },
    calculateColor() {
      if (this.customization.openGraphRandomColor) {
        return "#" + Math.floor(Math.random() * 16777215).toString(16)
      } else {
        return this.customization.openGraphColor
      }
    },
    calculateExpired(item) {
      if (!item.active) {
        return true
      } else if (new Date(item.expiredAt).valueOf() < new Date().valueOf()) {
        return true
      } else
        return (
          new Date(item.expiredAt).valueOf() < new Date().valueOf() &&
          !item.active
        )
    },
    calculateRelease() {
      if (this.$store.state.site.release === "dev") {
        return "Development"
      }
      if (this.$store.state.site.release === "main") {
        return "Mainline"
      } else if (this.$store.state.site.release === "beta") {
        return "Beta"
      } else if (this.$store.state.site.release === "prod") {
        return "Stable"
      } else {
        return this.$store.state.site.release
      }
    },
    startStatus() {
      this.interval = setInterval(() => {
        this.checkStatus()
      }, 2000)
    },
    endStatus() {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    checkStatus() {
      this.axios
        .get("/api/v1/billing/charges/" + this.credits.response.code)
        .then((res) => {
          if (res.data.payments[0]) {
            if (res.data.payments[0].status === "COMPLETED") {
              this.credits.stage = 4
              this.endStatus()
              this.$toast(
                "Thank you for depositing money into your Jays.host account, we hope you enjoy the various plans we have to offer.",
                {
                  timeout: 3000,
                  type: "success"
                }
              )
            }
          }
        })
        .catch((e) => {
          this.credits.cancelLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    copyAddress(item) {
      navigator.clipboard.writeText(item)
    },
    setCoin(coin) {
      this.credits.selectedCrypto = coin
      this.credits.stage = 3
    },
    calculateType() {
      if (this.$store.state.user.subscription.cancelled) {
        return "warning"
      } else {
        return "success"
      }
    },
    cancelPlan() {
      this.credits.cancelLoading = true
      this.axios
        .put("/api/v1/billing/cancel")
        .then(() => {
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              if (res.data.subscription) {
                this.$store.commit("setSubscription", res.data)
              }
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
          this.credits.cancelLoading = false
        })
        .catch((e) => {
          this.credits.cancelLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    initCredits() {
      this.credits.loading = true
      this.axios
        .post("/api/v1/billing/credits/init", {
          price: this.credits.amount
        })
        .then((res) => {
          this.credits.response = res.data
          this.credits.loading = false
          this.credits.stage = 2
          this.startStatus()
        })
        .catch((e) => {
          this.credits.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    calculateCost(price) {
      return price / 100
    },
    dayjs(params) {
      return dayjs(params)
    },
    getDiscordUserCache() {
      this.axios.get("/api/v1/userutils/info").then((res) => {
        this.$store.commit("setDiscordCache", res.data.discordUserCache)
      })
    },
    calculateDangerTOTP() {
      if (this.totp.disable.currentPassword) {
        return "error darken-1"
      } else if (this.totp.disable.code) {
        return "error darken-1"
      } else {
        return "success"
      }
    },
    saveWipeGallery() {
      this.wipeGallery.loading = true
      this.axios
        .put("/api/v1/userutils/settings/wipeGallerySettings", {
          time: this.wipeGallery.automated.time,
          selected: this.wipeGallery.automated.selected,
          password: this.wipeGallery.automated.currentPassword
        })
        .then(() => {
          this.wipeGallery.loading = false
        })
        .catch((e) => {
          this.wipeGallery.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doWipeGallery() {
      this.wipeGallery.loading = true
      this.axios
        .put("/api/v1/userutils/settings/wipeGallery", {
          password: this.wipeGallery.currentPassword
        })
        .then(() => {
          this.wipeGallery.loading = false
        })
        .catch((e) => {
          this.wipeGallery.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doEnable2FA() {
      this.totp.loading = true
      this.axios
        .put("/api/v1/userutils/settings/totpEnable", {
          password: this.totp.currentPassword
        })
        .then((res) => {
          this.totp.validate.token = res.data.secret
          this.totp.validate.url = res.data.url
          this.totp.loading = false
          this.totp.stage = 1
        })
        .catch((e) => {
          this.totp.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doDisable2FA() {
      this.totp.disable.loading = true
      this.axios
        .put("/api/v1/userutils/settings/totpDisable", {
          code: this.totp.disable.code,
          password: this.totp.disable.currentPassword
        })
        .then(() => {
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.$store.commit(
              "setDiscordCache",
              JSON.parse(res.data.discordUserCache)
            )
            this.totp.disable.loading = false
          })
        })
        .catch((e) => {
          this.totp.disable.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doValidate2FA() {
      this.totp.validate.loading = true
      this.axios
        .put("/api/v1/userutils/settings/totpValidate", {
          code: this.totp.validate.code
        })
        .then(() => {
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.$store.commit("setDiscordCache", res.data.discordUserCache)
            this.totp.validate.loading = false
            this.totp.stage = 0
          })
        })
        .catch((e) => {
          this.totp.validate.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    guildRoleRefresh() {
      this.externalAccounts.discord.guildRoleLoading = true
      this.axios
        .put("/api/v1/userutils/settings/discordGuildRefresh")
        .then(() => {
          this.externalAccounts.discord.guildRoleLoading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.externalAccounts.discord.guildRoleLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    unlinkDiscord() {
      this.externalAccounts.discord.discordUnlinkLoading = true
      this.axios
        .put("/api/v1/userutils/settings/unlinkDiscord")
        .then(() => {
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$store.commit("setDiscordCache", res.data.discordUserCache)
            this.$vuetify.theme.dark = res.data.darkTheme
            this.$toast("Action completed successfully.", {
              timeout: 3000,
              type: "success"
            })
          })
          this.externalAccounts.discord.discordUnlinkLoading = false
        })
        .catch((e) => {
          this.axios.get("/api/v1/userutils/info").then((res) => {
            this.$store.commit("login", res.data)
            this.$vuetify.theme.dark = res.data.darkTheme
          })
          this.externalAccounts.discord.discordUnlinkLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    discordSave() {
      this.externalAccounts.discord.saveLoading = true
      this.axios
        .put("/api/v1/userutils/settings/discordPreferences", {
          public: this.externalAccounts.discord.showOnProfile
        })
        .then(() => {
          this.externalAccounts.discord.saveLoading = false
        })
        .catch((e) => {
          this.externalAccounts.discord.saveLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    saveFileShareNix() {
      const data = JSON.stringify({
        DefaultFileUploader: this.$store.state.site.name,
        DefaultImageUploader: this.$store.state.site.name,

        Services: [
          {
            Version: "13.5.0",
            Name: this.$store.state.site.name,
            DestinationType: "ImageUploader, TextUploader, FileUploader",
            RequestType: "POST",
            RequestURL:
              this.$store.state.site.hostnameWithProtocol +
              "/api/v1/gallery/upload",
            Body: "MultipartFormData",
            Headers: {
              Authorization: this.apiKeys.selected
            },
            FileFormName: "attachment",
            URL: "$json:url$"
          }
        ]
      })
      const blob = new Blob([data], { type: "text/plain" })
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a")
      a.download =
        this.$store.state.user.username +
        " - " +
        this.$store.state.site.name +
        ".json"
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":")
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
      a.dispatchEvent(e)
    },
    setUploadNameHidden() {
      this.privacy.loading = true
      this.axios
        .put("/api/v1/userutils/settings/discordPrecache", {
          enabled: this.privacy.discordPrecache
        })
        .then(() => {
          this.privacy.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.privacy.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
      this.axios
        .put("/api/v1/userutils/settings/hideUploadUsername", {
          enabled: this.privacy.usernameHidden
        })
        .then(() => {
          this.privacy.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.privacy.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    removeAvatar() {
      this.avatar.loadingRemove = true
      this.axios
        .put("/api/v1/userutils/settings/removeAvatar")
        .then(() => {
          this.avatar.loadingRemove = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.avatar.loadingRemove = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    saveInvisibleURLs() {
      this.customization.loadingOther = true
      this.axios
        .put("/api/v1/userutils/settings/otherCustomization", {
          invisibleURLs: this.customization.invisibleURLs,
          customPath: this.customization.customPath
        })
        .then(() => {
          this.customization.loadingOther = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.customization.loadingOther = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeAvatar() {
      this.avatar.loading = true
      const data = new FormData()
      data.append("attachment", this.avatar.file)
      this.axios
        .post("/api/v1/userutils/settings/avatar", data)
        .then(() => {
          this.avatar.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.avatar.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeOpenGraph() {
      this.customization.loading = true
      this.axios
        .put("/api/v1/userutils/settings/openGraph", {
          openGraph: this.customization.openGraph,
          openGraphColor: this.customization.openGraphColor,
          openGraphDescription: this.customization.openGraphDescription,
          openGraphTitle: this.customization.openGraphTitle,
          openGraphSiteName: this.customization.openGraphSiteName,
          openGraphSiteURL: this.customization.openGraphSiteURL,
          oEmbedAuthorURL: this.customization.oEmbedAuthorURL,
          oEmbedAuthorName: this.customization.oEmbedAuthorName,
          openGraphRandomColor: this.customization.openGraphRandomColor
        })
        .then(() => {
          this.calculatePreview(
            this.customization.fakeData,
            this.customization.embedPreview
          )
          this.axios
            .put("/api/v1/userutils/settings/otherCustomization", {
              invisibleURLs: this.customization.invisibleURLs,
              customPath: this.customization.customPath,
              fakePath: this.customization.fakePath,
              fakePathValue: this.customization.fakePathValue
            })
            .then(() => {
              this.customization.loading = false
              this.$toast("Action completed successfully.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              this.customization.loading = false
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          this.customization.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    openGraphSet() {
      this.axios
        .get("/api/v1/userutils/info")
        .then((res) => {
          this.customization.openGraph = res.data.openGraph
          this.customization.openGraphColor = res.data.openGraphColor
          this.customization.openGraphSiteURL = res.data.openGraphSiteURL
          this.customization.openGraphSiteName = res.data.openGraphSiteName
          this.customization.openGraphAuthorURL = res.data.openGraphAuthorURL
          this.customization.openGraphAuthor = res.data.openGraphAuthor
          this.customization.openGraphTitle = res.data.openGraphTitle
          this.customization.openGraphDescription =
            res.data.openGraphDescription
          this.customization.oEmbedAuthorName =
            res.data.openGraphCustomFields.author_name
          this.customization.oEmbedAuthorURL =
            res.data.openGraphCustomFields.author_url
          this.customization.fakePath = res.data.fakePath
          this.customization.fakePathValue = res.data.fakePathValue
          this.externalAccounts.discord.showOnProfile = res.data.discordPublic
          this.privacy.usernameHidden = res.data.uploadNameHidden
          this.privacy.discordPrecache = res.data.discordPrecache
          this.customization.invisibleURLs = res.data.invisibleURLs
          this.customization.customPath = res.data.customPath
          this.wipeGallery.automated.time = res.data.automatedRemovalTime
          this.wipeGallery.automated.selected = res.data.automatedRemoval
          this.calculatePreview(
            this.customization.fakeData,
            this.customization.embedPreview
          )
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    saveFile: function () {
      const data = JSON.stringify({
        Version: "13.5.0",
        Name: this.$store.state.site.name,
        DestinationType: "ImageUploader, TextUploader, FileUploader",
        RequestMethod: "POST",
        RequestURL:
          this.$store.state.site.hostnameWithProtocol +
          "/api/v1/gallery/upload",
        Body: "MultipartFormData",
        Headers: {
          Authorization: this.apiKeys.selected
        },
        FileFormName: "attachment",
        URL: "$json:url$"
      })
      const blob = new Blob([data], { type: "text/plain" })
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a")
      a.download =
        this.$store.state.user.username +
        " - " +
        this.$store.state.site.name +
        ".sxcu"
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":")
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
      a.dispatchEvent(e)
    },
    changePassword() {
      this.password.loading = true
      this.axios
        .put("/api/v1/userutils/settings/password", {
          password: this.password.password,
          confirmPassword: this.password.confirmPassword,
          currentPassword: this.password.currentPassword
        })
        .then(() => {
          this.password.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.password.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeUsername() {
      this.username.loading = true
      this.axios
        .put("/api/v1/userutils/settings/username", {
          username: this.username.username,
          password: this.username.password
        })
        .then(() => {
          this.username.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.username.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeEmail() {
      this.email.loading = true
      this.axios
        .put("/api/v1/userutils/settings/email", {
          email: this.email.email,
          password: this.email.password
        })
        .then(() => {
          this.email.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.email.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    changeDescription() {
      this.description.loading = true
      this.axios
        .put("/api/v1/userutils/settings/description", {
          description: this.description.description
        })
        .then((res) => {
          this.description.loading = false
          this.$toast("Action completed successfully.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.description.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
    /*doDeleteAccount() {
      this.deleteAccount.loading = true
      this.axios
        .put("/api/v1/userutils/delete", {
          password: this.deleteAccount.currentPassword
        })
        .then(() => {
          this.deleteAccount.loading = false
          this.$store.commit("devLogin", "")
          this.$toast("Your account has been deleted.", {
            timeout: 3000,
            type: "success"
          })
        })
        .catch((e) => {
          this.deleteAccount.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }*/
  },
  mounted() {
    this.description.description = this.$store.state.user.description
    this.openGraphSet()
    this.getDiscordUserCache()
    this.getBio()
    this.getApiKeys()
  }
}
</script>
